// @mui
import { SvgIcon } from "@mui/material";

function SubscriptionIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      version="1.1"
      sx={{
        fill: "transparent",
        "& path": {
          stroke: (theme) => theme.palette.text.primary,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 13.5469V15.6339" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M5.87124 8.10742C4.24832 8.1551 3.18292 9.22148 3 10.7724"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4825 21.002H8.39648"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0078 21.0009C14.6307 20.9532 15.6961 19.8869 15.8791 18.3359"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.87124 21.0009C4.24832 20.9532 3.18292 19.8869 3 18.3359"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21 10.4532V8.36719" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18.1289 15.8935C19.7518 15.8458 20.8172 14.7794 21.0002 13.2285"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.5176 3H15.6036" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M10.9923 3C9.36942 3.04768 8.30401 4.11405 8.12109 5.66497"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1289 3C19.7518 3.04768 20.8172 4.11405 21.0002 5.66497"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2544 8.27539H13.7454C14.9656 8.27539 15.7254 9.13647 15.7254 10.3556V13.6452C15.7254 14.8634 14.9656 15.7254 13.7454 15.7254H10.2544C9.03431 15.7254 8.27539 14.8634 8.27539 13.6452V10.3556C8.27539 9.13647 9.0382 8.27539 10.2544 8.27539Z"
        stroke="#000000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default SubscriptionIcon;
